<template>
  <ModalTemplate :showModal='showModal' :width='widthModal' @closeModal='closeModal'>
    <template v-slot:headerModal>
      <div class='is-flex is-justify-content-space-between is-align-items-center'>
        <p class='averta-bold label-18'>Ringkasan Menunggu Pembayaran</p>
        <div class='is-clickable' @click='closeModal'>
          <b-icon icon='close'></b-icon>
        </div>
      </div>
    </template>
    <template v-slot:bodyModal>
      <div class='wrap-body-modal p-5'>
        <div class='loading-wrapper' v-if='isLoading'>
          <b-loading :is-full-page='false' v-model='isLoading' :can-cancel='false'>
            <SpinnerIcon />
          </b-loading>
        </div>

        <!-- List -->
        <!-- LIST YANG BARU - SAMA PERSIS DENGAN GAMBAR -->
        <div v-else class='wrap-list'>
          <div class="column is-12 mr-4 has-text-right mb-5">
            <div>
              <p class="label-20 averta-bold mb-4">
                Grand Total dari Menunggu Pembayaran
              </p>
              <p class="label-32 averta-bold">
                {{ formatThousand(summaryList[0].grand_total) }}
              </p>
            </div>
          </div>
          <!-- LOOP DATA PEMBAYARAN -->
          <div
            v-for='(item, index) in summaryList'
            :key='index'
            class='box pembayaran-box'
          >
            <!-- TITLE -->
            <div class='is-flex is-justify-content-space-between is-align-items-center'>
              <p class='label-20 averta-bold mb-4'>{{ item.title }}</p>
              <div class="live-clock is-flex is-align-items-center">
                <b-icon
                  icon="clock-outline"
                  size="is-small"
                  class="mr-1"
                ></b-icon>

                <span class="time-text">{{ nowFormatted }}</span>

                <span class="live-dot"></span>
              </div>
            </div>

            <div class='columns is-gapless'>

              <!-- LEFT TOTAL GREEN CARD -->
              <div class='column is-5 mr-4'>
                <div class='total-green-card p-5'>
                  <p class='label-14'>Total ({{ item.totalPeople }} project)</p>
                  <p class='label-32 averta-bold'> {{ formatThousand(item.totalAmount) }}</p>
                </div>
              </div>

              <div class='column is-1'>
              </div>
              <!-- RIGHT DETAIL BOXES -->
                <div class="detail-grid">
                  <div
                    v-for="(d, i) in item.details"
                    :key="i"
                    class="is-flex is-justify-content-space-between detail-payment"
                  >
                    <div class="detail-item">
                      <p class="details-14">{{ d.label }} ({{ d.people }} project)</p>
                      <p class="label-24 averta-bold">{{ formatThousand(d.amount) }}</p>
                    </div>
                  </div>

                  <!-- Vertical divider (antara kolom kiri dan kanan) -->
                  <b-divider
                    v-if="item.details.length > 1"
                    vertical
                    class="divider-vertical"
                  ></b-divider>

                  <!-- Horizontal divider setelah baris pertama (jika total >= 3) -->
                  <b-divider
                    v-if="item.details.length > 2"
                    class="divider-horizontal"
                  ></b-divider>
                </div>
            </div>

          </div>

        </div>

        <!-- List -->
      </div>
    </template>
  </ModalTemplate>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import ModalTemplate from './ModalTemplate.vue'
// import InputAutocomplete from '@/components/input/InputAutocomplete.vue'
import { SpinnerIcon } from '@/components/icons'
import {
  formatCurrencyReturnZero as formatCurrency
} from '@/helpers'
// import UpIcon from '@/components/icons/UpIcon.vue'

export default {
  name: 'ModalPaymentSummary',
  components: {
    ModalTemplate,
    // InputAutocomplete,
    SpinnerIcon
    // UpIcon
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user'
    }),
    nowFormatted () {
      return this.now.format('HH:mm:ss')
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '75vw'
    },
    isDashboard: {
      type: Boolean,
      default: false
    },
    dataNotifikasi: {
      type: Object,
      default: () => ({})
    },
    dataSummary: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      isLoading: false,
      isModalActive: false,
      widthModal: this.width,
      search: '',
      searchBy: '',
      vendor: null,
      currentPage: 1,
      totalPages: 0,
      totalData: 0,
      limitPage: 5,
      dataCard: {
        daily: {
          kuota: 0,
          survey_in_progress: 0,
          survey_complete: 0,
          offering_created: 0,
          target: 0
        }
      },
      summaryList: this.dataSummary,
      now: moment()
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    convertDate (date, format) {
      if (!date) {
        return '-'
      }
      let initFormat = 'DD MMMM YYYY'
      if (format) {
        initFormat = format
      }
      return moment(date).format(initFormat)
    },
    formatThousand (amount) {
      return formatCurrency(amount)
    },
    getSummary () {
      // Method untuk fetch data summary
      this.isLoading = true

      // Simulasi API call - ganti dengan actual API endpoint
      // TODO: Uncomment dan sesuaikan dengan actual API endpoint
      // this.$store.dispatch('projectV2/getPaymentSummary', body)
      //   .then(response => {
      //     this.dataCard = response.data.data
      //     this.isLoading = false
      //   })
      //   .catch(error => {
      //     console.error(error)
      //     this.isLoading = false
      //   })

      // Temporary: Simulasi data
      setTimeout(() => {
        this.dataCard = {
          daily: {
            kuota: 15,
            survey_in_progress: 8,
            survey_complete: 12,
            offering_created: 5,
            target: 75
          }
        }
        this.isLoading = false
      }, 1000)
    }
  },
  created () {
    if (this.showModal) {
      this.getSummary()
    }
  },
  watch: {
    showModal (newValue) {
      this.isModalActive = newValue
      if (newValue) {
        this.getSummary()
      }
    },
    width (newValue) {
      this.widthModal = newValue
    },
    search (newValue) {
      if (newValue === '') {
        this.getSummary()
      }
    },
    dataSummary (newValue) {
      console.log(newValue, 'new value summary data')
      this.summaryList = newValue
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.now = moment()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.border-right {
  border-right: solid 1px #9A9A9A;
}

.wrap-title-and-filter {
  border-bottom: dashed 2px #E5E5E5;
  padding-bottom: 24px;
  margin-bottom: 24px;
}

.wrap-body-modal {
  height: 75vh;
  overflow-y: auto;
}

.wrap-list {
  min-height: 30vh;
}

.loading-wrapper {
  height: 60%;
  width: 100%;
  position: relative;
}

.card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  color: white;
}

.card.col-2 {
  background: linear-gradient(135deg, #2df144 0%, #2b9103 100%);
}

.wave {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.3;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-body-proyek {
  position: relative;
  z-index: 1;
}

.flip-icon {
  transform: rotate(180deg);
}

.search-by-wrapper {
  min-width: 120px;
}

.vendor-wrapper {
  min-width: 300px;
}

.pembayaran-box {
  padding: 20px;
  border-radius: 12px !important;
  border: 1px solid #E0E0E0;
  overflow-y: auto;
}

.total-green-card {
  height: 100%;
  border-radius: 12px;
  background: linear-gradient(135deg, #14BF43, #68C181);
  color: white;
  position: relative;
  overflow: hidden;
}

.total-green-card::after {
  content: '';
  background-image: url("../../assets/img/wave-card.png");
  background-size: cover;
  opacity: 0.3;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.label-32 {
  font-size: 32px;
  line-height: 1.2;
}

.label-24 {
  font-size: 24px;
  line-height: 1.2;
}

.label-14 {
  font-size: 14px;
  margin-bottom: 20px;
  color: #FFFFFF;
}

.details-14 {
  font-size: 14px;
  color: #7A7A7A;
  margin-bottom: 5px;
}

.detail-grid {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 10px 0;
  width: 100%;
}

.detail-payment {
  width: 100%;
}

.detail-item {
  padding: 12px;
  width: 100%;
  margin-left: 15%;
}

/* Base style divider Buefy */
.detail-grid .b-divider {
  border-color: #E5E5E5 !important; /* warna divider */
}

/* Divider vertikal */
.divider-vertical {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  border-left: 1px solid #E5E5E5 !important;
}

/* Divider horizontal (row 1 & row 2) */
.divider-horizontal {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  border-top: 1px solid #E5E5E5 !important;
}

.live-clock {
  font-size: 13px;
  color: #6c757d;
}

.time-text {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.live-dot {
  width: 6px;
  height: 6px;
  background-color: #23d160; /* hijau live */
  border-radius: 50%;
  margin-left: 6px;
  animation: pulse 1.2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}

</style>
